import {ChangeDetectorRef, Component, ElementRef, forwardRef, Input} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractMultiselectInput} from "../abstract-multiselect-input";
import {FUIOptionsService} from "../../../framework/options.service";
import {FUIEventsService} from "../../../../events/events.service";
@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIInlineMultiselectInputComponent),
            multi: true
        }
    ],
    selector: "fui-inline-multiselect-input",
    styleUrls: ["../multiselect-input.scss"],
    templateUrl: "./inline-multiselect-input.component.html",
    standalone: false
})
export class FUIInlineMultiselectInputComponent extends FUIAbstractMultiselectInput {
    @Input() allowLabelMarkup: boolean = false;

    constructor(changeDetectorRef: ChangeDetectorRef,
                elementRef: ElementRef,
                eventsService: FUIEventsService,
                optionsService: FUIOptionsService) {
        super(changeDetectorRef, elementRef, eventsService, optionsService);
    }
}
